import { render } from "./QuizList.vue?vue&type=template&id=3d375089"
import script from "./QuizList.vue?vue&type=script&lang=js"
export * from "./QuizList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Desktop/samgk_quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__